import React from 'react'
import { ToastContainer, style } from 'react-toastify'
import Transition from 'react-transition-group/Transition'

import './Animation.css'

// https://github.com/fkhadra/react-toastify

const ToastTransition = ({ children, position, ...props }) => (
  <Transition
    {...props}
    timeout={300 - 50}
    onEnter={ node => node.classList.add('toastIn')}
    onExit={ node => {
      node.classList.remove('toastIn')
      node.classList.add('toastOut')
    }}
  >
    {children}
  </Transition>
)

const Toasts = () => (
  <ToastContainer
    position={'bottom-right'}
    closeButton={false}
    hideProgressBar={true}
    transition={ToastTransition}
    />
)

style({
  colorDefault: "hsl(240, 80%, 10%)",
  colorError: "hsl(350, 80%, 50%)",
})

export default Toasts



// WEBPACK FOOTER //
// ./src/views/misc/Toasts.jsx